import LinearLoader from '@trustoo/components/ui/LinearLoader'
import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface LoginBoxProps {
    title: ReactNode
    subtitle?: ReactNode
    /** Above the logo, e.g. to switch between logging in as a pro or as a consumer. */
    tabs?: ReactNode
    /** The brand logo, see `getLogoUrls()` in `@trustoo/utils/localeUtils`. */
    logoUrl: string
    /** Dims the content and runs a loader along the top edge. */
    isLoading?: boolean
    className?: string
    children?: ReactNode
}

/**
 * The bordered box an account page is shown in, such as logging in or changing a password: the
 * logo, a title and the page's own content.
 */
const LoginBox = ({
    title,
    subtitle,
    tabs,
    logoUrl,
    isLoading,
    className,
    children,
}: LoginBoxProps) => (
    <div
        className={twMerge(
            'relative box-border w-full max-w-[400px] rounded-lg border border-[#dadada] bg-white',
            className,
        )}>
        <div className={twMerge('p-6 transition-opacity duration-200', isLoading && 'opacity-50')}>
            {tabs}
            <div className="my-3 text-center">
                <img src={logoUrl} width={150} alt="Logo" className="inline-block max-w-[115px]" />
            </div>
            <div className="text-center">
                <h1 className="m-0 text-lg font-normal leading-8">{title}</h1>
                {subtitle && <p className="mt-1 text-md text-[#717680]">{subtitle}</p>}
            </div>
            {children}
        </div>
        {isLoading && (
            <div className="absolute left-0 top-0 w-full">
                <LinearLoader />
            </div>
        )}
    </div>
)

export default LoginBox
